import React from "react";
import { Container, Box, Dialog, DialogTitle, DialogContent, Grid, Typography, CircularProgress, Alert } from "@mui/material";
import { FacilityApproversList } from "./FacilityApproversList";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { DepartmentApproversList } from "./DepartmentApproversList";
import { FacilityApproverForm } from "../../approverSettings/FacilityApproverForm";
import { DepartmentApproverForm } from "../../approverSettings/DepartmentApproverForm";
import { toggleDepartmentApproverDialog, toggleFacilityApproverDialog } from "../../../../../app/slices/TicketEasyModuleSlice";
import { usePermissions } from "../../../hooks/usePermissions";

export const ApproversConfiguration: React.FC = () => {
    const dispatch = useAppDispatch();
    const { isAdmin, isLoading, error } = usePermissions();
    const facilityDialogOpen = useAppSelector(state => state.ticketEasyModule.FacilityApproverDialogOpen);
    const departmentDialogOpen = useAppSelector(state => state.ticketEasyModule.DepartmentApproverDialogOpen);

    if (isLoading) {
        return (
            <Container>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    if (error) {
        return (
            <Container>
                <Alert severity="error">
                    Error loading user profile. Please refresh the page and try again.
                </Alert>
            </Container>
        );
    }

    if (!isAdmin) {
        return (
            <Container>
                <Alert severity="warning">
                    You do not have permission to access the Approvers Configuration section.
                </Alert>
            </Container>
        );
    }

    return (
        <Container maxWidth="xl">
            <Typography variant="h5" gutterBottom align="center" sx={{ mb: 3 }}>
                Approvers Configuration
            </Typography>
            
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Box sx={{ border: "1px solid #ccc", borderRadius: 3, padding: 2, height: "100%" }}>
                        <FacilityApproversList 
                            onAddClick={() => { dispatch(toggleFacilityApproverDialog()); }} 
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box sx={{ border: "1px solid #ccc", borderRadius: 3, padding: 2, height: "100%" }}>
                        <DepartmentApproversList
                            onAddClick={() => { dispatch(toggleDepartmentApproverDialog()); }} 
                        />
                    </Box>
                </Grid>
            </Grid>
            
            <Dialog open={facilityDialogOpen} onClose={() => dispatch(toggleFacilityApproverDialog())} fullWidth maxWidth="md">
                <DialogTitle>Configure Facility Approver</DialogTitle>
                <DialogContent>
                    <FacilityApproverForm />
                </DialogContent>               
            </Dialog>
            
            <Dialog open={departmentDialogOpen} onClose={() => dispatch(toggleDepartmentApproverDialog())} fullWidth maxWidth="md">
                <DialogTitle>Configure Department Approver</DialogTitle>
                <DialogContent>
                    <DepartmentApproverForm />
                </DialogContent>               
            </Dialog>
        </Container>
    );
};